import { createStyles, makeStyles, Theme } from "@material-ui/core";
import {
  green600,
  red700,
  pink900,
  pink50,
  purple900,
  purple50,
  orange900,
  orange50,
} from "../constants";

export const useAccordionCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.06)",
      width: "100%",
      minHeight: 64,
      borderRadius: 16,
      marginBottom: 12,
      border: "1px solid rgba(0,0,0,0.08)",
      padding: "16px 24px",
      opacity: 1,
      boxSizing: "border-box",
      "&:before": {
        display: "none",
      },
    },
    icon: {
      color: "#000000",
      fontSize: "28px",
    },
    acordionSummary: {
      padding: 0,
      margin: 0,
      borderBottom: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "stretch",
      "& .MuiAccordionSummary-expandIcon": {
        transition: "transform 0.2s",
      },
    },
    [theme.breakpoints.down("sm")]: {
      root: {
        padding: "12px 16px",
      },
      icon: {
        fontSize: "24px",
      },
      header: {
        gap: 12,
      },
      heading: {
        fontSize: "18px",
      },
      badge: {
        width: 36,
        height: 36,
        fontSize: "18px",
      },
    },
    header: {
      display: "flex",
      alignItems: "center",
      gap: 18,
      width: "100%",
      padding: 0,
      justifyContent: "flex-start",
    },
    badge: {
      width: 44,
      height: 44,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 800,
      color: "currentColor",
      fontSize: "22px",
      opacity: 0.95,
    },
    blue: {
      backgroundColor: "#DBEAFE",
      color: "#155DFC",
    },
    red: {
      backgroundColor: "rgba(231, 0, 11, 0.13)",
      color: red700,
    },
    green: {
      backgroundColor: "rgba(34, 156, 39, 0.12)",
      color: green600,
    },
    pink: {
      backgroundColor: pink50,
      color: pink900,
    },
    purple: {
      backgroundColor: purple50,
      color: purple900,
    },
    orange: {
      backgroundColor: orange50,
      color: orange900,
    },
    gradient: {
      background:
        "linear-gradient(90deg, rgba(12, 223, 212, 0.14) 0%, rgba(40, 232, 105, 0.14) 100%)",
      color: "#003350",
    },
    gray: {
      backgroundColor: "rgba(107, 114, 128, 0.18)",
      color: "#374151",
    },
    heading: {
      fontFamily: "Inter, sans-serif",
      fontSize: "26px",
      color: "#111827",
      fontWeight: 700,
      lineHeight: 1.2,
      letterSpacing: "0.2px",
      [theme.breakpoints.down("sm")]: { fontSize: "20px" },
    },
    subtitle: {
      color: "#6A7282",
      letterSpacing: "0.05px",
    },
    details: {
      padding: "12px 16px 16px",
    },
  })
);
